import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OloPayTerminalService {
  public terminalID: string = '03499411';
  public pinPadMACAddress: string;
  public pinPadType: string;
  public pinPadProvider: string = 'olo-pay';
  public pinPadAddressType: string = 'MAC';

  private pinPadMACAddressKey = 'pinPadMacAddress';
  private pinPadTypeKey = 'pinPadType';
  private pinPadProviderKey = 'pinPadProvider';
  private pinPadAddressTypeKey = 'pinPadAddressType';
  private terminalIDKey = 'terminalID';

  constructor() {
    const storedType = this.getStoredPinPadType();
    if (storedType) {
      this.pinPadType = storedType;
    }
    const storedProvider = this.getStoredPinPadProvider();
    if (storedProvider) {
      this.pinPadProvider = storedProvider;
    }
    const storedAddress = this.getStoredPinPadMACAddress();
    if (storedAddress) {
      this.pinPadMACAddress = storedAddress;
    }
    const storedAddressType = this.getStoredPinPadAddressType();
    if (storedAddressType) {
      this.pinPadAddressType = storedAddressType;
    }
    const storedTerminalID = this.getStoredTerminalID();
    if (storedTerminalID) {
      this.terminalID = storedTerminalID;
    }
  }

  updateStoredPinPadMACAddress(newPinPadMACAddress: string) {
    this.pinPadMACAddress = newPinPadMACAddress;
    localStorage.setItem(this.pinPadMACAddressKey, newPinPadMACAddress);
  }

  updateStoredPinPadType(newPinPadType: string) {
    this.pinPadType = newPinPadType;
    localStorage.setItem(this.pinPadTypeKey, newPinPadType);
  }

  updateStoredPinPadProvider(newPinPadProvider: string) {
    this.pinPadProvider = newPinPadProvider;
    localStorage.setItem(this.pinPadProviderKey, newPinPadProvider);
  }

  updateStoredPinPadAddressType(newPinPadAddressType: string) {
    this.pinPadAddressType = newPinPadAddressType;
    localStorage.setItem(this.pinPadAddressTypeKey, newPinPadAddressType);
  }

  getStoredPinPadMACAddress(): string {
    return localStorage.getItem(this.pinPadMACAddressKey);
  }

  getStoredPinPadType(): string {
    return localStorage.getItem(this.pinPadTypeKey);
  }

  getStoredPinPadProvider(): string {
    return localStorage.getItem(this.pinPadProviderKey);
  }

  getStoredPinPadAddressType(): string {
    return localStorage.getItem(this.pinPadAddressTypeKey);
  }

  clearStoredPinPadMACAddress() {
    localStorage.removeItem(this.pinPadMACAddressKey);
  }

  clearStoredPinPadType() {
    localStorage.removeItem(this.pinPadTypeKey);
  }

  clearStoredPinPadProvider() {
    localStorage.removeItem(this.pinPadProviderKey);
  }

  clearStoredPinPadAddressType() {
    localStorage.removeItem(this.pinPadAddressTypeKey);
  }

  updateStoredTerminalID(newTerminalID: string) {
    this.terminalID = newTerminalID;
    localStorage.setItem(this.terminalIDKey, newTerminalID);
  }

  getStoredTerminalID(): string {
    return localStorage.getItem(this.terminalIDKey);
  }

  clearStoredTerminalID() {
    localStorage.removeItem(this.terminalIDKey);
  }

  /**
   * Check if the current terminal is configured for olo-pay
   */
  isOloPayTerminal(): boolean {
    return this.pinPadProvider === 'olo-pay';
  }

  /**
   * Get the terminal configuration for olo-pay
   */
  getTerminalConfig() {
    return {
      terminalId: this.pinPadMACAddress,
      pinPadMACAddress: this.pinPadMACAddress,
      pinPadType: this.pinPadType,
      pinPadProvider: this.pinPadProvider,
      pinPadAddressType: this.pinPadAddressType,
    };
  }
}
